export default "__VITE_ASSET__gDLUAzRU55KKid46nqVi3w__"